import React from "react";
import './GlovalCard.scss'
const GlovalCard = ({ children, className = "", style }) => {
    return (
        <div className={`GlovalCard ${className}`} style={style}>
            <div className="contenidoGlovalCard">
                {children}
            </div>
        </div>
    )
}
export default GlovalCard